<template>
<div class="liveSourceList">
  <!-- source输入框 -->
  <div
      class="searchInput"
      >
      <el-input
        v-model="sourceCondition"
        :placeholder="$t('lang.select')"
        class="SearchInput"
        @input="getSearchSource"
        ></el-input>
      <i
        class="el-icon-arrow-up"
        :class="showSourceList?'icon-arrow-reverse':'icon-arrow-caret'"
        @click.stop="showSource"></i>
  </div>
  <!-- source列表 -->
  <el-collapse  class="liveSource" v-model="activeName" @change="handleChange" v-if="showSourceList" @click.native.stop="" v-loading='liveSourceLoading'>
    <el-collapse-item :name="SourceItem.type" v-for="(SourceItem,i) in SourceClassify" :key="i">
      <template slot="title">
        <i v-if="!SourceItem.switch" class="el-icon-caret-right"></i>
         <i  v-else class="el-icon-caret-bottom"></i>{{$t('lang.'+(SourceItem.type))}}{{` (${SourceItem.total})`}}
      </template>
        <div v-for="item in SourceItem.list" :key="item.id" class="live-item">
          <div class="item" :title="item.name" @click="selectSource(item)" v-if="SourceItem.type=='ext'&&item.type=='RTP'">
            {{ EXTName(item) }}
          </div>
          <div class="item" :title="item.name" @click="selectSource(item)" v-else>
            {{item.name}}
          </div>
        </div>
    </el-collapse-item>
    <el-collapse-item v-if="!SourceClassify.length" class="noDataCollapse">
      <template slot="title">
         <div class="noData">{{ $t('lang.noData') }}</div>
      </template>
    </el-collapse-item>
  </el-collapse>

</div>

</template>

<script>
import { SourceClassifyConfig, InquireSourceParam } from '@/assets/js/temConfig.js'
import Outil from '@/assets/js/utils.js'
export default {
  data () {
    return {
      // 分类列表
      SourceClassifyConfig: JSON.parse(JSON.stringify(SourceClassifyConfig)),
      // 分类参数
      InquireSourceParam: JSON.parse(JSON.stringify(InquireSourceParam)),
      // 打开的折叠面板
      activeName: [],
      // input 的值
      sourceCondition: '',
      // 列表是否打开
      showSourceList: false,
      sourceData: {},
      // source列表信息
      SourceClassify: [],
      liveSourceLoading: false
    }
  },
  mounted () {
    // document.addEventListener('click', this.clickOthers)
  },
  watch: {
    showSourceList: {
      handler (val) {
        if (!val) {
          document.removeEventListener('click', this.clickOthers)
        } else {
          document.addEventListener('click', this.clickOthers)
        }
      },
      immediate: true
    }
  },
  methods: {
    // input输入搜索数据
    getSearchSource (val) {
      this.getSourceList(val)
      this.$emit('sourceInput', val)
    },
    // 点击不是liveSource和el-input__inner的地方关闭列表
    clickOthers (e) {
      const thisClassName = e.target.className
      if (thisClassName != 'liveSource' && thisClassName != 'el-input__inner') {
        this.showSourceList = false
      }
    },
    // 点击按钮打开列表
    showSource () {
      this.showSourceList = !this.showSourceList
      this.activeName = []
      if (this.showSourceList) {
        this.getSourceList()
      }

      // if (this.showSourceList) {
      //   this.showSourceList = false
      // } else {
      //   this.activeName = []
      //   this.getSourceList()
      // }
    },
    // 获取source 数据
    getSourceList (condition) {
      this.liveSourceLoading = true
      this.showSourceList = true
      this.SourceClassify = []
      const params = {
        rid: '',
        condition: condition || '',
        origin: 6,
        pageNum: 1,
        pageSize: 1000,
        queryList: ['ext', 'pack', 'anywhere', 'gridsdi', 'gridpack', 'rtmp'],
        relationExt: true,
        showAudioLevel: true
      }
      // if (type) params = this.InquireSourceParam[type]
      // if (this.sourceCondition) {
      //   params.condition = this.sourceCondition
      //   params.pageSize = 1000
      // }
      params.userId = Outil.getProgramReceiver('ownerUserId')
      // 排序方式
      params.sort = true
      params.rid = Outil.getProgramReceiver().peerId
      params.relationExt = true
      params.showAudioLevel = true
      // if (params.pageNum == 1) {
      //   this.sourceDataLoading = true
      // }
      // 获取source 数据
      this.$getSourcePage({
        ...this.$TVU,
        params: params,
        success: (val) => { // 接口成功的回调，返回result
          const activeNameList = []
          this.liveSourceLoading = false
          Object.keys(val).forEach(v => {
            val[v].type = v
            val[v].switch = false
            this.SourceClassify.push(val[v])
          })
          // 过滤长度为0的
          this.SourceClassify = this.SourceClassify.filter(v => {
            return v.total
          })
          for (const key in val) {
            // 如果搜索的那一项有长度 展开此项 没有长度关闭此项
            if (condition) {
              if (val[key].list && val[key].list.length) {
                activeNameList.push(key)
                this.activeName = activeNameList
              } else {
                if (this.activeName.includes(key)) {
                  this.activeName.splice(this.activeName.indexOf(key), 1)
                }
              }
            } else {
              this.activeName = []
            }
          //   if (!val[key].list) val[key].list = []
          //   if (params.pageNum == 1) {
          //     this.sourceData[key] = val[key].list
          //   } else {
          //     this.$set(this.sourceData, key, this.sourceData[key].concat(val[key].list))
          //   }
          //   if (this.InquireSourceParam[key]) {
          //     this.InquireSourceParam[key].hasNextPage = val[key].hasNextPage
          //     this.InquireSourceParam[key].total = val[key].total
          //     // this.$forceUpdate()
          //   }
          }
          // this.showSourceList = true
        },
        error: function (val) { /// /接口失败的回调，会包含失败的状态码
          // this.sourceDataLoading = false
          console.log(val)
        }
      })
    },
    // ext名称展示
    EXTName (item) {
      if (!item.displayName) {
        return ''
      }
      const displayNameArr = item.displayName && item.displayName.split(',')
      let displayName
      if (displayNameArr[1] && displayNameArr[2]) {
        displayName = displayNameArr[0] + '(' + displayNameArr[1] + '/' + displayNameArr[2] + ')'
      } else if (displayNameArr[1] && !displayNameArr[2]) {
        displayName = displayNameArr[0] + '(' + displayNameArr[1] + ')'
      } else if (!displayNameArr[1] && !displayNameArr[2]) {
        displayName = item.name
      }
      return displayName
    },
    // 选择source
    selectSource (item) {
      console.log(item)
      this.sourceCondition = item.name
      this.$emit('selectSource', item)
      this.showSourceList = false
    },
    // source展开
    handleChange (data) {
      this.SourceClassify.forEach((item) => {
        if (this.activeName.includes(item.type)) {
          item.switch = true
        } else {
          item.switch = false
        }
      })
    }
  },
  destroyed () {
    document.removeEventListener('click', this.clickOthers)
  }
}
</script>

<style scoped lang="less">
.liveSourceList{
  position: relative;
  .searchInput {
    position: relative;
  ::v-deep.el-input__inner{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    i {
      position: absolute;
      right: 11px;
      font-size: 14px;
      top: 13px;
      z-index: 1001;
      cursor: pointer;
      transition: transform .3s;
    }
    .icon-arrow-caret{
       transform: rotateZ(180deg);
    }
    .icon-arrow-reverse{
      transform: rotateZ(0deg);
    }
  }
  .el-collapse{
    position: absolute;
    width: 100%;
    z-index: 99999;
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.5);
    border: none;
    background: #444444;
    height: 200px;
    padding-bottom: 10px;
    // max-height: 300px;
    overflow-y: auto;
    ::v-deep.el-collapse-item{
      .el-collapse-item__header{
        height: 32px;
        background: #444444;
        color: #cccccc;
        font-size: 12px;
        border: none;
        padding-left: 10px;
        i{
          padding-right: 6px;
        }
        .el-collapse-item__arrow{
          display: none;
        }
      }
      .el-collapse-item__wrap{
        background: #444444;
        border: none;
        .el-collapse-item__content{
          padding-bottom:0;
          color: #cccccc;
          font-size: 12px;
          cursor: pointer;
          text-align: left;
          // padding-left: 20px;
          .live-item{
            height: 32px;
            line-height: 32px;
            .item{
              padding-left: 26px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
          .live-item:hover{
            background: rgba(57, 170, 80, 0.25)
          }
          .noData{
            text-align: center;
            color: #666666
          }
        }
      }
    }
    ::v-deep.noDataCollapse{
      height: 100%;
      .el-collapse-item__header{
        justify-content: center;
        height: 190px;
      }
    }
  }
}

</style>
